import {ActiveInfoPageConfig} from '@/components/Ui/ActiveInfoPage/BZCore/ActiveInfoPage'

import respName from '@/components/Resp/page/blocks/name.vue'
import respQuests from '@/components/Resp/page/blocks/quests.vue'


const config: ActiveInfoPageConfig = {
  mapsColumns: {
    lg: [['name', 'quests']],
  },
  blocks: {
    name: {
      block: respName,
      options: {}
    },
    quests: {
      block: respQuests,
      options: {}
    },
  },
  styles: {'grid-template-columns': '1fr'}
}
export default config